import { Td, Text, Tr } from "@chakra-ui/react";
import { ContractTaskDto } from "../../../autogen/bff-api";
import { displayWrappedWithEllipsis } from "../../../common/formatting/displayWrappedWithEllipsis";
import { useDisplayDate } from "../../../common/formatting/useDisplayDate";
import { ContractTaskResponsibleParty } from "../view-single/tasks/ContractTaskResponsibleParty";
import { ContractTaskStatusTag } from "../view-single/tasks/ContractTaskStatusTag";
import { ContractOwner } from "./ContractOwner";
import { ContractTitle } from "./ContractTitle";
import { fixedWidth, TASK_COLUMN_WIDTHS } from "./taskColumnWidths";

interface Props {
  task: ContractTaskDto;
  showTask: (id: string) => void;
}

export const TaskRow = ({ task, showTask }: Props) => {
  const displayDate = useDisplayDate();
  return (
    <Tr
      key={task.id}
      _hover={{ backgroundColor: "smBackgroundSecondary", cursor: "pointer" }}
      onClick={() => showTask(task.id)}
    >
      <Td {...fixedWidth(TASK_COLUMN_WIDTHS.title)}>
        <Text fontSize={"sm"}>{displayWrappedWithEllipsis(task.title, 40)}</Text>
      </Td>
      <Td {...fixedWidth(TASK_COLUMN_WIDTHS.dueDate)}>
        <Text fontSize={"sm"}>{displayDate(task.dueDate)}</Text>
      </Td>
      <Td {...fixedWidth(TASK_COLUMN_WIDTHS.responsible)}>
        <ContractTaskResponsibleParty task={task} />
      </Td>
      <Td {...fixedWidth(TASK_COLUMN_WIDTHS.contract)}>
        <ContractTitle task={task} />
      </Td>
      <Td {...fixedWidth(TASK_COLUMN_WIDTHS.owner)}>
        <ContractOwner task={task} />
      </Td>
      <Td {...fixedWidth(TASK_COLUMN_WIDTHS.status)}>
        <ContractTaskStatusTag status={task.displayStatus} size="sm" />
      </Td>
    </Tr>
  );
};
